import React,{Component} from 'react';
import {locale} from '../locale/AppLocale';

export default class Loader extends Component  {

    render() {

        let className = this.props.className?this.props.className:'';
        className+= ' loader';

        if(this.props.completed === false) {
            return (
                <div className={className}>
                    <svg className="circular" viewBox="25 25 50 50">
                        <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="2"
                                strokeMiterlimit="10"/>
                    </svg>
                </div>
            );
        }else if(this.props.completed === 0){
            return (
                <div className="panel-1--body">{locale.get('error_page_not_found')}</div>
            );
        }
        else{
            return (
                <div className={this.props.className}>{ this.props.children }</div>
            );
        }

    }
}

